import { Controller } from '@hotwired/stimulus';

import { renderReturnsGraph } from '../graphs/performance-returns-graph';

export type LineValue = {
  group: string;
  displayName: string;
  dataSeriesName: string;
  color_class: string;
  returnsByDate: Array<{ date: string; value: string }>;
};

export default class extends Controller<HTMLElement> {
  declare linesValue: LineValue[];

  static values = { lines: Array };

  linesValueChanged(): void {
    this.render();
  }

  render(): void {
    const lines = this.linesValue.map(line => ({
      ...line,
      returnsByDate: line.returnsByDate.map(point => ({
        date: new Date(point.date),
        value: parseFloat(point.value),
      })),
    }));

    this.element.replaceChildren();
    renderReturnsGraph(this.element, { lines });
  }
}
